import { Link } from "react-router-dom";
import Post from "../Post";
import Spacing from "../Spacing";
import React, { useState } from "react";
import Section from "../Section";
import FaqSectionStyle2 from "../Section/FaqSection/FaqSectionStyle2";
import { pageTitle } from "../../helpers/PageTitle";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import ContactForm from "../ContactForm";
import FaqSectionStyle4 from "../FaqSection/FaqSectionStyle4";
import BlogSection from "../Section/BlogSection";
import DepartmentSectionStyle2 from "../Section/DepartmentSection/DepartmentSectionStyle2";
import FeaturesSectionStyle5 from "../Feature/FeaturesSectionStyle5";
import { Helmet } from "react-helmet";
import styled from "styled-components";

const featureListData = [
  {
    iconUrl: "/images/home_4/compassion.svg",
    title: "Advanced Infrastructure",
    subTitle:
      "We understand that seeking medical care can be a stressful experience, and we strive to provide world-class infrastructure to achieve the best results for our patients.",

    subTitles:
      "'I got the best possible treatment and owe it to the Doctor and Staff! I sincerely followed his diagnosis and recommended treatment and it worked wonders! Very caring and concerned!'",
    ratingNumber: "5",
    Name: "Kavita Sinha",
  },
  {
    iconUrl: "/images/home_4/excellence.svg",
    title: "High IVF Success Rate",
    subTitle:
      "We believe in continuously updating our technologies and improving our skills and resources to ensure that we deliver the best quality care possible. We are happy and proud to say that we have been providing excellent IVF success rates.",

    subTitles:
      "'The Gynecologist took a great care  of me throught out my pregnacies. would definitely recommend others.'",
    ratingNumber: "4.5",
    Name: "Preeti Singh",
  },
  {
    iconUrl: "/images/home_4/integrity.svg",
    title: "Cost Effective",
    subTitle: `We believe in practicing medicine with integrity and honesty. We have designed comprehensive, highly affordable packages with the aim of providing advanced fertility services to as many people as possible.`,
    subTitles:
      "'ONe of my freind suggest this gynecologist after we had some trouble conceiving children.But now after their effective treatment I am very happy'",
    ratingNumber: "4.0",
    Name: "Sonia Mehra",
  },
  {
    iconUrl: "/images/home_4/respect.svg",
    title: "Transparency",
    subTitle:
      "We treat all individuals with respect, compassion, and kindness, regardless of their background, beliefs, or circumstances. We are transparent in our communications and decision-making processes, and we always put our patients' interests first.",
    subTitles:
      "'I got the best possible treatment and owe it to the Doctor and Staff! I sincerely followed his diagnosis and recommended treatment and it worked wonders! Very caring and concerned!'",
    ratingNumber: "5",
    Name: "Kavita Sinha",
  },
  {
    iconUrl: "/images/home_4/teamwork.svg",
    title: "Support",
    subTitle:
      "We believe in providing a comprehensive support system, thus providing everything from basic treatment to advanced care. We have a highly skilled team to ensure in-depth investigations, perfect individualized treatment plans, advanced endoscopic fertility-enhancing surgeries, the highest quality fertility treatment, and excellent management of high-risk pregnancies.",
    subTitles:
      "'The Gynecologist took a great care  of me throught out my pregnacies. would definitely recommend others.'",
    ratingNumber: "4.5",
    Name: "Preeti Singh",
  },
];
const faqData = [
  {
    title: "What is the purpose of fertility counselling?",
    content:
      "Fertility counselling aims to provide emotional support, guidance, and education to individuals and couples experiencing fertility issues. It helps address the emotional challenges associated with infertility, assist in making informed decisions about treatment options, and offers coping strategies for managing stress and anxiety during the fertility journey.",
  },
  {
    title: "How can fertility counselling help me during my treatment?",
    content:
      "Fertility counselling can help you by providing a safe space to express your feelings, offering techniques to manage stress and anxiety, and guiding you through the emotional ups and downs of treatment. Regular sessions can help you stay emotionally balanced and supported, ensuring you are better prepared to handle the outcomes of your fertility treatments.",
  },
  {
    title: " Is fertility counselling confidential?",
    content:
      "Yes, all counselling sessions at Pluro Jabalpur Fertility Centre are completely confidential. Your privacy is of utmost importance to us, and we ensure that your personal information and discussions during counselling remain secure and private.",
  },
  {
    title: "When should I consider seeking fertility counselling",
    content:
      "You should consider seeking fertility counseling before, during, and after fertility treatments, as well as anytime you feel overwhelmed, anxious, or need emotional support related to fertility issues.",
  },
  {
    title:
      "How do I schedule a counselling session at Pluro Jabalpur Fertility Centre?",
    content:
      "To schedule a counselling session, you can contact Pluro Jabalpur Fertility Centre directly. Our compassionate team is here to assist you in booking an appointment at a convenient time. You can reach us through our website, phone, or by visiting our clinic in person.",
  },
];
const blogData = [
  {
    title: "The Benefits of Mindfulness Meditation for Stress and Anxiety",
    thumbUrl: "images/blog/post_2.jpeg",
    date: "May 1, 2023",
    btnText: "Learn More",
    href: "/blog/blog-details",
    socialShare: true,
  },
];
const departmentData = [
  {
    title: "Emotional Support",
    subTitle:
      "Coping strategies, managing stress and anxiety, dealing with disappointment.",
    iconUrl: "/images/icons/calendar_white.svg",
    href: "#",
    // /departments/department-details
  },
  {
    title: "Education",
    subTitle:
      "Information about IVF procedures, success rates, risks, and side effects to help you make informed decisions.",
    iconUrl: "/images/icons/calendar_white.svg",
    href: "#",
    // href: "/departments/department-details",
  },
  {
    title: "Psychological Preparation",
    subTitle:
      " Preparing mentally for each stage of the IVF process, handling hormonal changes.",
    iconUrl: "/images/icons/calendar_white.svg",
    href: "#",
    // href: "/departments/department-details",
  },
  {
    title: "Relationship Support",
    subTitle:
      "Helping you and your partner navigate the impact of IVF on your relationship, enhancing communication and mutual support.",
    iconUrl: "/images/icons/calendar_white.svg",
    href: "#",
    // href: "/departments/department-details",
  },
  {
    title: "Ethical and Legal Guidance",
    subTitle:
      "Discussing ethical considerations, legal implications, and consent forms.",
    iconUrl: "/images/icons/calendar_white.svg",
    href: "#",
    // href: "/departments/department-details",
  },
  {
    title: "Long-term Planning",
    subTitle:
      "Assisting with future family planning, including discussions on parenthood and explaining IVF to future children.",
    iconUrl: "/images/icons/calendar_white.svg",
    href: "#",
    // href: "/departments/department-details",
  },
];
export default function Counselling() {
  const [activeFaq, setActiveFaq] = useState(0);

  return (
    <>
      <Helmet>
        <title>Fertility Counselling & Emotional Support</title>
        <meta name="description" content="Professional fertility counselling to support you emotionally and guide you through every step of your parenthood journey." />
        <meta name="keywords" content="fertility counselling, emotional support, IVF counselling, infertility guidance" />
        <link rel="canonical" href="https://jabalpurivfcentre.com/Counselling" />
      </Helmet>

      <div className="cs_counselling_new">
        <BannerSectionStyle3
          bgUrl="/images/Counselling.jpeg"
          title="Welcome to <br/> Pluro Jabalpur<br /> Fertility Center"
          subTitle="Counselling Services at Pluro Jabalpur Fertility Centre"
        />
        {/* 1. Intro Section */ }
        <section className="cs_counselling_intro">
          <div className="container">
            <div className="cs_counselling_intro_row">
              <div className="cs_intro_col_left">
                <h1>
                  Empowering Your Fertility Journey:<br />
                  <span>Compassionate Counseling</span>
                </h1>
                <p className="cs_intro_lead">
                  At Pluro Jabalpur Fertility Centre, we understand that dealing with fertility issues can be emotionally challenging. Our dedicated counselling services are designed to provide you with compassionate support, guidance, and resources throughout your fertility journey. Led by experienced counsellors and under the expert guidance of Dr. Archana Shrivastava, the Best IVF Doctor in Jabalpur, our counselling team is committed to addressing your emotional needs and helping you make informed decisions about your fertility treatment.
                </p>
              </div>
              <div className="cs_intro_col_right">
                <div className="cs_intro_card">
                  <div className="cs_intro_card_icon">
                    <img src="/images/icons/calendar_white.svg" alt="Icon" style={ { width: '30px', filter: 'brightness(0) invert(1)' } } />
                  </div>
                  <h2>Why Counselling is Important</h2>
                  <p>
                    Facing infertility or undergoing fertility treatments can evoke a range of emotions, including stress, anxiety, grief, and uncertainty. Our counselling services are tailored to support you through these emotional challenges.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 2. Services Grid Section */ }
        <section className="cs_counselling_services">
          <div className="container">
            <div className="cs_section_heading">
              <h2>Our Counseling Services</h2>
            </div>
            <div className="cs_counselling_grid">
              { departmentData.map((item, index) => (
                <div className="cs_counselling_card" key={ index }>
                  <div className="cs_card_icon">
                    <img src={ item.iconUrl } alt={ item.title } />
                  </div>
                  <h3 className="cs_card_title">{ item.title }</h3>
                  <p className="cs_card_desc">{ item.subTitle }</p>
                </div>
              )) }
            </div>
          </div>
        </section>

        {/* 3. Why Choose Us Section */ }
        <section className="cs_counselling_features">
          <div className="container">
            <div className="cs_section_heading">
              <h2>Why Choose Us</h2>
            </div>
            <div className="cs_feature_testimonial_grid">
              { featureListData.map((item, index) => (
                <div className="cs_ft_card" key={ index }>
                  <div className="cs_ft_header">
                    <div className="cs_ft_icon">
                      <img src={ item.iconUrl } alt={ item.title } />
                    </div>
                    <h3 className="cs_ft_title">{ item.title }</h3>
                  </div>
                  <div className="cs_ft_body">
                    <p className="cs_ft_desc">{ item.subTitle }</p>
                    <div className="cs_ft_testimonial">
                      <span className="cs_ft_quote_mark">“</span>
                      <p className="cs_ft_quote_text">{ item.subTitles }</p>
                      <div className="cs_ft_author_row">
                        <p className="cs_ft_author_name">- { item.Name }</p>
                        <div className="cs_ft_rating">
                          ★★★★★
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )) }
            </div>
          </div>
        </section>

        {/* 4. FAQ Section */ }
        <Section>
          <FaqSectionStyle4
            sectionTitle="Frequently Asked <br />Questions"
            data={ faqData }
            faqImgUrl="/images/home_4/faq_img.jpg"
            spiningImgUrl="/images/home_1/about_mini.svg"
          />
        </Section>

        {/* Contact Us Section */}
        <Section topMd={ 60 } topLg={ 40 } topXl={ 20 } bottomMd={ 100 } bottomLg={ 80 } bottomXl={ 60 }>
          <div className="container">
            <div className="cs_ivf_contact_banner" style={ { background: '#c77842', borderRadius: '20px', padding: '60px 50px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '30px' } }>
              <div className="cs_icc_content" style={ { flex: '1', minWidth: '300px' } }>
                <h2 style={ { color: '#fff', fontSize: '36px', marginBottom: '15px', fontWeight: '700' } }>Contact Us</h2>
                <p style={ { color: 'rgba(255,255,255,0.9)', fontSize: '18px', margin: '0', lineHeight: '1.6' } }>
                  If you are considering IVF as a fertility treatment option,
                  contact Jabalpur Fertility Centre today. Our expert team is
                  here to guide you through the process and help you achieve
                  your dream of starting a family.
                </p>
              </div>
              <div className="cs_icc_action">
                <Link to="/contact" className="cs_btn" style={ { background: '#fff', color: '#c77842', padding: '15px 40px', borderRadius: '50px', fontWeight: '600', fontSize: '18px', display: 'inline-flex', alignItems: 'center', textDecoration: 'none', boxShadow: '0 10px 20px rgba(0,0,0,0.1)' } }>
                  <span>Get in Touch</span>
                </Link>
              </div>
            </div>
          </div>
        </Section>

        {/* Related Articles Section */}
        <Section bottomMd={ 200 } bottomLg={ 150 } bottomXl={ 110 }>
          <div className="container">
            <h2 className="mb-0 cs_fs_40 cs_medium">Related Articles</h2>
            <Spacing md="57" />
            <div className="row cs_gap_y_40">
              { [
                {
                  title: "The Importance of Mental Health: Understanding and Managing Anxiety Disorders",
                  thumbUrl: "/images/blog/post_1.jpeg",
                  date: "March 12",
                  btnText: "Learn More",
                  href: "/blog/blog-details",
                }
              ].map((item, index) => (
                <div className="col-xl-12" key={ index }>
                  <Post { ...item } />
                </div>
              )) }
            </div>
          </div>
        </Section>


        {/* 5. Success Stories Section */ }
        {/* <section className="cs_counselling_blog">
          <div className="container">
            <div className="cs_section_heading">
              <h2>Success Stories</h2>
            </div>
            {blogData.map((item, index) => (
              <div className="cs_story_card" key={index}>
                <div className="cs_story_img">
                  <img src={item.thumbUrl} alt={item.title} />
                  <span className="cs_story_date">{item.date}</span>
                </div>
                <div className="cs_story_content">
                  <h3>{item.title}</h3>
                  <a href={item.href} className="cs_story_btn">
                    {item.btnText}
                    <div className="cs_btn_icon">→</div>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section> */}
      </div>
    </>
  );
}
